import { cancelAutorefillIcon } from "@trueskin-web/theme/icons/cancelAutorefillIcon"
import { crossCircleIcon } from "@trueskin-web/theme/icons/crossCircleIcon"
import { deliveryIcon } from "@trueskin-web/theme/icons/deliveryIcon"
import { refillIcon } from "@trueskin-web/theme/icons/refillIcon"
import { Trans } from "@trueskin-web/translations"

const plans = {
  preset_formel_only_bimonthly_xl_AG_436_anti_aging_exp: {
    title: "Essential",
    description: "Auto-Refill, 2-Monats-Set",
    details: [
      {
        content:
          "Deine medizinische Formel mit effektiven Wirkstoffen, um Deine Haut zu verjüngen.",
      },
      {
        content:
          "Unsere Ärzt:innen beraten Dich, ob Deine aktuellen Reinigungs- und Pflegeprodukte dazu passen.",
      },
      {
        content:
          "Bekomme alle 2 Monate eine neue Formel (XX €/2 Monate). Jederzeit ganz einfach kündbar.",
      },
    ],
  },
  preset_sub_bimonthly_xl_AG_436_anti_aging_exp: {
    title: "Advanced",
    description: "Auto-Refill, 2-Monats-Set",
    details: [
      {
        content: "Die ideale 3-Step-Routine für beste Anti-Aging-Ergebnisse.",
      },
      {
        content:
          "Ergänzend zu Deiner medizinischen Formel erhältst Du das passende Reinigungsgel und die passende Feuchtigkeitscreme.",
      },
      {
        content:
          "Bekomme alle 2 Monate ein neues Set (XX €/2 Monate). Jederzeit ganz einfach kündbar.",
      },
    ],
  },
  preset_sub_bimonthly_xl_w_spf_AG_436_anti_aging_exp: {
    title: "Complete",
    description: "Auto-Refill, 2-Monats-Set",
    details: [
      {
        content:
          "Unsere 3-Step-Routine ergänzt um unseren Sonnenschutz mit LSF 50.",
      },
      {
        content:
          "Leicht auf der Haut, aber maximaler Schutz gegen Hautalterung.",
      },
      {
        content:
          "Bekomme alle 2 Monate ein neues Set (XX €/2 Monate). Jederzeit ganz einfach kündbar.",
      },
    ],
  },
  preset_formel_only_sub_one_month_AG_436_anti_aging_exp: {
    title: "Essential",
    details: [
      {
        content:
          "Deine medizinische Formel mit effektiven Wirkstoffen, um Deine Haut zu verjüngen.",
      },
      {
        content:
          "Unsere Ärzt:innen beraten Dich, ob Deine aktuellen Reinigungs- und Pflegeprodukte dazu passen.",
      },
      {
        content: "Bekomme jeden Monat eine neue Formel.",
      },
    ],
  },
  preset_sub_one_month_AG_436_anti_aging_exp: {
    title: "Advanced",
    details: [
      {
        content: "Die ideale 3-Step-Routine für beste Anti-Aging-Ergebnisse.",
      },
      {
        content:
          "Ergänzend zu Deiner medizinischen Formel erhältst Du das passende Reinigungsgel und die passende Feuchtigkeitscreme.",
      },
      {
        content: "Bekomme jeden Monat in neues Set.",
      },
    ],
  },
  preset_sub_one_month_w_spf_AG_436_anti_aging_exp: {
    title: "Complete",
    details: [
      {
        content:
          "Unsere 3-Step-Routine ergänzt um unseren Sonnenschutz mit LSF 50.",
      },
      {
        content:
          "Leicht auf der Haut, aber maximaler Schutz gegen Hautalterung.",
      },
      {
        content: "Bekomme jeden Monat ein neues Set.",
      },
    ],
  },
  preset_prescription: {
    details: [
      {
        content:
          "Erhalte ein medizinisches Rezept, keine Zulieferung vom FORMEL SKIN-Set",
        icon: crossCircleIcon,
        theme: "rose",
      },
      {
        content: "Keine laufende Formel-Anpassung",
        icon: crossCircleIcon,
        theme: "rose",
      },
      {
        content:
          "Ca. 35€ zusätzliche Herstellungskosten in der Apotheke und Wartezeit",
        icon: crossCircleIcon,
        theme: "rose",
      },
    ],
  },
}

const faqs = [
  {
    icon: refillIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.0.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.0.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },
  {
    icon: deliveryIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.1.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.1.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },
  {
    icon: cancelAutorefillIcon,
    question: <Trans i18nKey="ChoosePlan.Faqs.items.3.question" />,
    answer: (
      <Trans i18nKey="ChoosePlan.Faqs.items.3.answer">
        <span sx={{ fontWeight: "bold" }} />
      </Trans>
    ),
  },
]

export { plans, faqs }
